var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBghead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 158,
    viewBox: "0 0 375 158",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V131.867C375 131.867 324.5 158 187.5 158C50.5 158 0 131.867 0 131.867V0Z",
    fill: "#C4E2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V131.867C375 131.867 324.5 158 187.5 158C50.5 158 0 131.867 0 131.867V0Z",
    fill: "url(#paint0_linear_121_5776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_5776",
    x1: 188,
    y1: 79.4365,
    x2: 188,
    y2: -38.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#2D4EA3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#3A77A2",
    stopOpacity: 0.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBghead);
export default __webpack_public_path__ + "static/media/bghead.28176b9d969d79f3bbbb231c3da8ca00.svg";
export { ForwardRef as ReactComponent };